"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var listNumberFormat_1 = require("./listNumberFormat");
/**
 * domyslne fotmatowania dla określonych poziomów
 */
var DEFAULT_TYPE = ['1.', 'a)', 'i.'];
/**
 * Oblicza następny numer na liście
 *
 * @export
 * @param {number[]} levels lista ostatnich wartości na każdym poziomie zagnieżdzenia
 * @param {number} [level=0] poziom zagnieżdzenia, domyślnie 0
 * @param {string} [type] typ formatowania, domyslnie wyliczany na podstawieni poziomu zagnieżdzenia: 1. -> a) -> i.
 * @param {number} [value] ręczne ustawienie wartości, ma wpływ na dalszą numerację
 * @returns {string} zwraca sformatowy tekst odpowieadający kolejnej wartości
 */
function nextListNumber(levels, level, type, value) {
    if (level === void 0) { level = 0; }
    var result = '';
    if (!type) {
        type = DEFAULT_TYPE[level % 3];
    }
    if (value === undefined) {
        value = (levels[level] || 0) + 1;
    }
    switch (type) {
        case '1.1.':
        case '1.1.1.':
            result = value + '.';
            for (var i = level - 1; i >= 0; i--) {
                result = levels[i] + '.' + result;
            }
            break;
        case '1.1':
        case '1.1.1':
            result = '' + value;
            for (var i = level - 1; i >= 0; i--) {
                result = levels[i] + '.' + result;
            }
            break;
        default:
            result = listNumberFormat_1.default(value, type);
    }
    levels[level] = value;
    levels.length = level + 1;
    return result;
}
exports.default = nextListNumber;
//# sourceMappingURL=nextListNumber.js.map